import React from "react";

import { useAppSelector } from "store";
import { CostChapter, selectCurrentChapter } from "modules/customer/insights/cost/costSlice";

import CostOverview from "./costOverview/CostOverview";
import CostDrivers from "./costDrivers/CostDrivers";
import StoreCosts from "./storeCosts/StoreCosts";
import StoreCostActions from "./storeCostActions/StoreCostActions";

const Insight: React.FC = () => {
    const currentChapter = useAppSelector(selectCurrentChapter);

    return (
        <>
            {currentChapter === CostChapter.CostOverview && (
                <CostOverview />
            )}
            {currentChapter === CostChapter.CostDrivers && (
                <CostDrivers />
            )}
            {currentChapter === CostChapter.StoreCosts && (
                <StoreCosts />
            )}
            {currentChapter === CostChapter.StoreCostActions && (
                <StoreCostActions />
            )}
        </>
    );
};

export default Insight;
